import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//Components
import DataTable from "react-data-table-component";
import Constants from "../../../common/SupplierConstants";
import { useDispatch, useSelector } from "react-redux";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import StatisticsContainer from "../../../Components/Cards/StatisticsCardContainer";
import MultiColumnFilter from "../../../Components/Filter/MultiColumnFilter";
import ItemService from "../../../services/ap_auto_appCommonService";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import Layout from "../../../Layout/Layout";
import { SearchField } from "../../../Components/formElements/SearchField";
import StickyColumn from "../../../Components/Sticky/StickyColumn";
import { useNavigate } from "react-router-dom";
import {
  addAPINV,
  getAPInvList,
} from "../../../redux/feature/ap_auto_app/apAutoSlice";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import { currencyFormat, formatDateTime } from "../../../common/Validations";
import AP_AUTOConstants from "../../../common/AP_AUTOConstants";
import SourcingCommonFilter from "../../../Components/Filter/Sourcing/SourcingCommonFilter";
import CancelModal from "../../../Components/CancleModal/CancelModal";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import toast from "react-hot-toast";
import ShowStatus from "../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import PaymentModal from "./PaymentModal";
import TableActions from "../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";
const DEFAULT_LIST_PARAMS = {
  queryName: "Get_APEXPInvoice_List",
  module: "",
  page: 1,
  per_page: 10,
};
const ApInvoiceList = () => {
  const dispatch = useDispatch();
  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  // const [filterShow, setFilterShow] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);

  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);

  const [getModalEditInvoice, setModalEditInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  const showPaymentModal = (documentNumber) => {
    let obj = {
      documentNumber,
    };
    setModalEditInvoice(true);
    setInvoiceData(obj);
  };
  const hidePaymentModal = () => {
    setModalEditInvoice(false);
  };

  // eslint-disable-next-line
  const [filteredData, setFilteredData] = useState([]);
  // const [getFileViewData, setFileViewData] = useState(null);
  let apExpInv = useSelector((state) => state?.apauto?.apInv);
  let entryTable = useSelector((state) => state?.apauto?.apInv?.pagination);

  const navigate = useNavigate();
  const tableData = apExpInv?.data || [];
  useEffect(() => {
    if (!showStats) {
      setFilteredData(apExpInv?.data);
    }
  }, [showStats, apExpInv]);
  // eslint-disable-next-line
  const [data, setData] = useState();
  // eslint-disable-next-line
  const [modalUpdate, setModalUpdate] = useState(false);
  // eslint-disable-next-line
  const [modalDeleteQuotationJob, setModalDeleteQuotationJob] = useState(false);
  // eslint-disable-next-line
  const [getEntryListData, setEntryListData] = useState();

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  // const handleViewFile = (fileAttachmentId) => {
  //   setFileViewData(fileAttachmentId);
  //   setShowFileViewModal(true);
  // };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const handleCancelAPI = async (payload) => {
    try {
      const res = await ItemService.cancleAPInvoice(payload); // your cancel API call

      if (res?.status === 200) {
        dispatch(getAPInvList(DEFAULT_LIST_PARAMS));
        return res;
      } else {
        toast.error(res?.message || "Cancel failed. Please try again!", {
          duration: 4000,
          position: "top-right",
        });
        return res;
      }
    } catch (err) {
      console.error("Cancel API Error:", err);
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    }
  };
  // eslint-disable-next-line
  const refreshInvoiceList = () => {
    dispatch(getAPInvList());
  };

  const loadQuotationData = async () => {
    setData(apExpInv?.data);
  };

  const showUpdateModal = () => {
    setModalUpdate(true);
  };

  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = () => {
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  const [getSelectedRows, setSelectedRows] = useState([]);
  // const handleRowSelected = ({ selectedRows }) => {
  //   const validRows = selectedRows.filter(
  //     (item) => item?.invoiceStatusHeader !== "Cancelled",
  //   );
  //   setSelectedRows(validRows);
  // };

  // ✅ Spread to always create new reference
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.invoiceStatusHeader !== "Cancelled",
    );
    setSelectedRows([...validRows]); // 🔥 spread here
  };
  // eslint-disable-next-line
  const hideUpdateModal = () => {
    setModalUpdate(false);
  };
  const handleCreate = () => {
    navigate(AP_AUTOConstants.AP_EXP_INV_CREATE);
    console.log(AP_AUTOConstants.AP_EXP_INV_CREATE);
  };
  // eslint-disable-next-line
  const handleEditClick = (row) => {
    dispatch(addAPINV(row));
    showUpdateModal("EDIT", row.documentNumber);
  };

  const detailedPageInvoice = (invoiceNumber) => {
    dispatch(addAPINV(invoiceNumber));
    navigate(AP_AUTOConstants.AP_EXP_INV_DETAILS);
  };

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };
  // Fetch Filtered Data
  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "Get_APEXPInvoice_List",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getAPInvList(obj));
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_APEXPInvoice_List",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getAPInvList(obj));
    setData(apExpInv?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_APEXPInvoice_List",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getAPInvList(obj));
    setData(apExpInv?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_APEXPInvoice_List",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getAPInvList(obj));
  };

  useEffect(() => {
    loadQuotationData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apExpInv]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Get_APEXPInvoice_List",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getAPInvList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const invoiceList = [
    {
      name: "Invoice Number",
      selector: (row) => row.documentNumber,
      id: "documentNumber",
      range: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageInvoice(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Payment",
      cell: (row) => (
        <>
          <button
            className="btnInfo"
            onClick={() => showPaymentModal(row.documentNumber)}
          >
            Pyament
          </button>
        </>
      ),
      width: "120px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    // ✅ KEEP THIS — uses tableData which is always []  or populated from Redux
    ...(tableData?.some((row) => row.workflowActionLogs !== undefined)
      ? [
          {
            name: "Workflow log",
            selector: (row) => row.workflowActionLogs,
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
              >
                <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowActionLogs)} // ✅ onClick is here
                />
              </div>
            ),
            sortable: true,
            width: "132px",
          },
        ]
      : []),
    // {
    //   name: "Status",
    //   cell: (row) => (
    //     <>
    //       <span className="bg-table-status bg-table-new-status">
    //         {row.invoiceStatusHeader}
    //       </span>
    //     </>
    //   ),
    //   width: "180px",
    // },
    // Conditionally include the 'workflowActionLogs' column
    {
      name: "Status",
      selector: (row) => row.invoiceStatusHeader,
      id: "invoiceStatusHeader",
      dropDown: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.invoiceStatusHeader} />
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Invoice Date",
      selector: (row) => row.vendorInvoiceDate,
      id: "vendorInvoiceDate",
      month: true,
      sortable: true,
      width: "130px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      dropDown: true,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },

    {
      name: "Invoice Value",
      selector: (row) => row.vendorTotalInvoiceValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.vendorTotalInvoiceValue).toFixed(2))}
        </span>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Currency",
      selector: (row) => row.vendorInvoiceCurrency,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorInvoiceCurrency} </p>
          <p className="m-0 p-0">{row.currency} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "PO/SA Number",
      selector: (row) => row.purchasingDocumentNr,
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailedPagePO(row.purchasingDocumentNr)}
        >
          {row.purchasingDocumentNr}
        </button>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "PO/SA Date/Time",
      selector: (row) => formatDateTime(row?.purchasingDocumentDate) || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP Invoice",
      selector: (row) => row.invoiceItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "Posted On",
      selector: (row) => row.grnItemNr,
      sortable: true,
      width: "130px",
    },
    // {
    //   name: "GRN Value",
    //   selector: (row) => row.purchasingDocumentItemNr,
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "GRN Number",
    //   selector: (row) => row.purchasingDocumentItemNr,
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "GRN Value",
    //   selector: (row) => row.purchasingDocumentItemNr,
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Cancelled INV Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled INV Date",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled INV Remark",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "Action",
      cell: (row) => (
        <TableActions
          actions={[
            {
              label: "Details",
              icon: "bi bi-info-circle",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Edit",
              icon: "bi bi-pencil-square",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Delete",
              icon: "bi bi-trash",
              iconClass: "text-danger",
              bg: "#fdeaea",
              // onClick: () => deleteMaterial(row),
            },
            {
              label: "More",
              icon: "bi bi-three-dots",
              bg: "#f1f3f5",
              // onClick: () => console.log("More", row),
            },
          ]}
        />
      ),
      width: "180px",
    },
  ];

  const columnsForFilter = invoiceList
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));
  //delete
  // eslint-disable-next-line
  const deleteQuotaionJob = (data) => {
    setModalDeleteQuotationJob(true);
    setEntryListData(data);
  };
  // eslint-disable-next-line
  const hideModal = () => {
    setModalDeleteQuotationJob(false);
  };

  const lineItemColInfo = [
    {
      name: "Inv Item Nr",
      cell: (row) => <span>{row.invoiceItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    // {
    //   name: "Material Desc",
    //   cell: (row) => <span>{row.materialDescription} </span>,
    //   width: "220px",
    // },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialClass2} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Invoice Quantity",
      cell: (row) => <span>{row.invoiceQuantity} </span>,
      width: "220px",
    },
    {
      name: "Item Net Value",
      cell: (row) => <span>{row.totalPrice} </span>,
      width: "220px",
    },
    {
      name: "Item Tax Value",
      cell: (row) => <span>{row.invItemTaxValue} </span>,
      width: "220px",
    },
    {
      name: "PO Nr",
      cell: (row) => <span>{row.purchasingDocumentNr} </span>,
      width: "220px",
    },
    {
      name: "PO Item Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
    {
      name: "Schedule Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
  ];

  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">AP Expense Invoice</h2>
                <p className="subText">
                  Lists of AP Expense Invoice and details
                </p>
                <Col xs={12} md={8} lg={8}></Col>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>
            <hr />

            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>

                <StatisticsContainer
                  api={ItemService.generateCustomerQuery}
                  keyName="invoiceStatusHeader"
                  paginatedList={apExpInv.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                  queryName="Get_APEXPInvoice_List"
                />
              </div>
            )}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AI</span>
                    </Col>
                    <Col xs={6} md={8} lg={8}>
                      <span className="headerTitle">AP Invoice</span>
                    </Col>
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <Col xs={6} md={6} lg={6}>
                        <button className="btnTable" onClick={handleCreate}>
                          <i className="bi bi-receipt"></i> Expense Invoice
                        </button>
                      </Col>
                      <Col xs={6} md={6} lg={6}>
                        <button
                          className="btnTable"
                          onClick={cancelModalShow}
                          disabled={getSelectedRows.length > 0 ? false : true}
                        >
                          <i className="bi bi-x-circle"></i> Cancel
                        </button>
                      </Col>
                      <Col xs="auto" md="auto" lg="auto">
                        <SourcingCommonFilter />
                      </Col>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>
                          <li>
                            <span>
                              <i className="bi bi-download"></i>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <StickyColumn
                          columnIndexes={[2]}
                          leftOffsets={[0, 160]}
                        />
                        <DataTable
                          title=""
                          columns={invoiceList}
                          // data={data}
                          data={tableData}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          onChangeRowsPerPage={handlePerRowsChange}
                          paginationTotalRows={entryTable?.total}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {/* <EntryModel
        show={modalQuotation}
        onHide={() => hideModalStatus()}
        key={modalQuotation ? "open" : "closed"}
      />
      <EntryModel
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
      /> */}
      {/* <BudgetUpdate show={modalUpdate} onHide={() => hideUpdateModal()} /> */}
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        // fileid={getFileViewData}
      />
      {/* <CancelModal
        title="Cancel the Invoice"
        type="Invoice"
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
        onConfirm={handleCancelAPI}
        docKey="invoiceNr"
      /> */}
      <CancelModal
        title="Cancel the Invoice"
        type="Invoice"
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
        onConfirm={handleCancelAPI}
        docKey="documentNumber"
        onSuccess={() => {
          setSelectedRows([]);
          // dispatch(getAPInvList());
          dispatch(getAPInvList(DEFAULT_LIST_PARAMS));
        }}
      />
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />

      <PaymentModal
        show={getModalEditInvoice}
        onHide={() => hidePaymentModal()}
        invoiceinfo={invoiceData}
      />
    </main>
  );
};

export default ApInvoiceList;
